import React from 'react';
import { Home, Phone, Mail, Calculator, FileText, MessageSquare, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { LogoOption1 } from '../components/LogoOptions';

export const NotFound = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center px-4">
      <div className="max-w-3xl w-full py-12">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <LogoOption1 className="h-20" />
        </div>

        {/* Main 404 Card */}
        <Card className="border-2 border-blue-200 shadow-2xl mb-8">
          <CardContent className="p-8 sm:p-12 text-center">
            {/* 404 Number */}
            <div className="text-8xl sm:text-9xl font-bold text-blue-600 mb-4 opacity-20">
              404
            </div>

            {/* Main Message */}
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Oops! Page Not Found
            </h1>
            
            <p className="text-xl text-gray-600 mb-8">
              The page you&apos;re looking for doesn&apos;t exist or has been moved.
            </p>

            {/* Primary Action */}
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-lg px-8 py-6 mb-6"
              onClick={() => window.location.href = '/'}
            >
              <Home className="w-5 h-5 mr-2" />
              Go to Homepage
            </Button>

            {/* Quick Contact */}
            <div className="border-t border-gray-200 pt-6 mt-6">
              <p className="text-gray-600 mb-4">
                <strong>Need help?</strong> I&apos;m here to assist you.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  variant="outline"
                  onClick={() => window.location.href = 'tel:+17203078711'}
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Call (720) 307-8711
                </Button>

                <Button
                  variant="outline"
                  onClick={() => window.location.href = 'mailto:info@milehighreverse.com'}
                >
                  <Mail className="w-4 h-4 mr-2" />
                  Email Me
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Popular Pages Suggestions */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4 text-center">
            Popular Pages You Might Be Looking For:
          </h2>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
            {/* Calculator */}
            <button
              onClick={() => window.location.href = '/#calculator'}
              className="flex items-center space-x-3 p-4 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-all"
            >
              <Calculator className="w-6 h-6 text-blue-600" />
              <div className="text-left">
                <div className="font-semibold text-gray-900">Calculator</div>
                <div className="text-sm text-gray-600">Estimate benefits</div>
              </div>
            </button>

            {/* Free Guide */}
            <button
              onClick={() => window.location.href = '/reverse-mortgage-tax-guide.html'}
              className="flex items-center space-x-3 p-4 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-all"
            >
              <FileText className="w-6 h-6 text-blue-600" />
              <div className="text-left">
                <div className="font-semibold text-gray-900">Free Tax & Retirement Guide</div>
                <div className="text-sm text-gray-600">Complete planning information</div>
              </div>
            </button>

            {/* Contact */}
            <button
              onClick={() => window.location.href = '/#contact'}
              className="flex items-center space-x-3 p-4 border border-gray-200 rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-all"
            >
              <MessageSquare className="w-6 h-6 text-blue-600" />
              <div className="text-left">
                <div className="font-semibold text-gray-900">Get Quote</div>
                <div className="text-sm text-gray-600">Free analysis</div>
              </div>
            </button>
          </div>
        </div>

        {/* Back Link */}
        <div className="text-center">
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back to Previous Page
          </button>
        </div>

        {/* Footer Info */}
        <div className="text-center mt-8 text-sm text-gray-600">
          <p>Peter Andrew S., CPA & Licensed Mortgage Specialist | NMLS #2575736</p>
          <p className="mt-1">Serving Colorado homeowners 62+</p>
        </div>
      </div>
    </div>
  );
};
